import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface ToggleViewOptionProps {
  active: boolean;
  disabled?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}

const OptionComponent: React.FC<ToggleViewOptionProps> = ({
  active,
  disabled,
  onClick,
  children,
}) => {
  return (
    <button
      className={`peptalk-toggle-option ${active ? 'active' : ''}`}
      onClick={onClick}
      type="button"
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export const Option: React.FC<ToggleViewOptionProps> = (
  props: ToggleViewOptionProps
) => {
  const Component = useCustomComponent({
    componentName: 'ToggleViewOption',
    Component: OptionComponent,
  });

  return <Component {...props} />;
};
